import { DASHBOARD_URL } from "@/constants/environment.constants";

export function redirectToDashboard(path?: string) {
  const _path = path?.startsWith("/") ? path.substring(1) : path;
  window.location.href = `${DASHBOARD_URL}${_path ?? ""}`;
}

export function getNumberRoute(lineId: string) {
  return `/numbers/${lineId}`;
}

export function getNumberSettingsRoute(lineId: string) {
  return `${getNumberRoute(lineId)}/settings`;
}
